export const ALL_CATEGORY = "all";
export const CONTACT_ID = "contact";
export const DEFAULT_BG_COLOR = "primary";
export const DESKTOP = "desktop";
export const MOBILE = "mobile";
export const TABLET = "tablet";
